'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
function MessageForm(_ref) {
	var disabled = _ref.disabled;
	var onChange = _ref.onChange;
	var onSubmit = _ref.onSubmit;
	var intl = _ref.intl;

	var handleChange = function handleChange(event) {
		return onChange(event.target.value);
	};

	var handleSubmit = function handleSubmit(event) {
		event.preventDefault();
		onSubmit(event.target.text.value);
		event.target.text.value = '';
	};

	return _react2.default.createElement(
		'form',
		{ className: 'vtChat-MessageForm vtChat-Form', onSubmit: handleSubmit },
		_react2.default.createElement('input', {
			className: 'vtChat-Form-input',
			name: 'text',
			type: 'text',
			disabled: disabled,
			onChange: handleChange,
			title: intl.formatMessage({
				id: 'vtChat.MessageForm.message.title'
			}),
			placeholder: intl.formatMessage({
				id: 'vtChat.MessageForm.message.placeholder'
			}),
			required: true
		}),
		_react2.default.createElement('input', {
			className: 'vtChat-Form-submit vtChat-Button',
			type: 'submit',
			disabled: disabled,
			value: intl.formatMessage({
				id: 'vtChat.MessageForm.submit'
			})
		})
	);
}

MessageForm.propTypes = {
	disabled: _react.PropTypes.bool.isRequired,
	onChange: _react.PropTypes.func,
	onSubmit: _react.PropTypes.func,
	intl: _reactIntl.intlShape
};

MessageForm.defaultProps = {
	disabled: false,
	onChange: _lodash.noop,
	onSubmit: _lodash.noop
};

exports.default = (0, _reactIntl.injectIntl)(MessageForm);